import * as React from 'react'
import {
  getBreakpointClassName,
  getBreakpointsArr,
  getValueClassName
} from '../../../data/abitilies/Breakpoint'
import Marker from './Marker'

import './style.scss'

interface IProps {
  value?: number
  showAllBreakpoints?: boolean
  isHidePrecent?: boolean
}

interface IState {}

export class Progress extends React.Component<IProps, IState> {
  private max = 100
  render() {
    const { value, showAllBreakpoints, isHidePrecent } = this.props
    const val = value !== undefined ? value : this.max

    const breakpointArr = getBreakpointsArr()
    const tiles: JSX.Element[] = breakpointArr
      .filter(
        (b, i) =>
          val >= b ||
          (i > 0 && val >= breakpointArr[i - 1]) ||
          (i === 0 && val < breakpointArr[i] && val > -1)
      )
      .map((b, i) => {
        const width = Math.min(b, val) - (i === 0 ? 0 : breakpointArr[i - 1])
        return (
          <div
            key={b}
            className={`tile ${getBreakpointClassName(breakpointArr[i])}`}
            style={{
              width: `${width}%`,
              left: i === 0 ? 0 : `${breakpointArr[i - 1]}%`
            }}
          />
        )
      })

    return (
      <div className="statistic-level design-fixes">
        {tiles}
        {!isHidePrecent &&
        value !== undefined &&
        value >= 0 &&
        value <= this.max ? (
          <Marker value={Math.ceil(val)} className={getValueClassName(val)} />
        ) : null}
        {showAllBreakpoints &&
          breakpointArr.map(b => (
            <Marker key={b} value={b} className={getBreakpointClassName(b)} />
          ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Statistic/Progress/index.tsx